// extracted by mini-css-extract-plugin
export default {"contenedor":"EliminarModal_contenedor__vxjwg","texto":"EliminarModal_texto__cExEl","aclaracion":"EliminarModal_aclaracion__mTOR4","pendiente":"EliminarModal_pendiente__0piON"};